import applicationKeys from "@swa-ui/application/i18nKeys";
import authenticationKeys from "@swa-ui/authentication/i18nKeys";
import { getBootstrapData } from "@swa-ui/bootstrap";
import currencyKeys from "@swa-ui/currency/i18nKeys";
import dotcomKeys from "@swa-ui/dotcom/i18nKeys";
import formKeys from "@swa-ui/form/i18nKeys";
import inflightKeys from "@swa-ui/inflight/i18nKeys";
import itineraryKeys from "@swa-ui/itinerary/i18nKeys";
import { setI18nRoot, setLang } from "@swa-ui/locale";
import placementsKeys from "@swa-ui/placements/i18nKeys";

import AppKeys from "../components/App/App.i18n";
import ErrorPageKeys from "../components/ErrorPage/ErrorPage.i18n";
import LoadingShimmerKeys from "../components/LoadingShimmer/LoadingShimmer.i18n";
import MemberWifiStatusDetailsKeys from "../components/MemberWifiStatusDetails/MemberWifiStatusDetails.i18n";
import HomeKeys from "../pages/HomePage/HomePage.i18n";

const i18nOverrides = getBootstrapData("swa-bootstrap-i18n/i18n-override");

setLang("global");
setI18nRoot({
  global: {
    ...AppKeys,
    ...applicationKeys,
    ...authenticationKeys,
    ...currencyKeys,
    ...dotcomKeys,
    ...ErrorPageKeys,
    ...formKeys,
    ...HomeKeys,
    ...inflightKeys,
    ...itineraryKeys,
    ...LoadingShimmerKeys,
    ...MemberWifiStatusDetailsKeys,
    ...placementsKeys,
    ...i18nOverrides?.global,
  },
});
